// Utilidades de seguridad para el frontend

/**
 * Sanitiza una entrada para prevenir XSS
 * @param {string} input - Entrada a sanitizar
 * @returns {string} - Entrada sanitizada
 */
export const sanitizeInput = (input) => {
  if (typeof input !== "string") return "";

  return input
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#x27;")
    .replace(/\//g, "&#x2F;");
};

/**
 * Valida una entrada según el tipo
 * @param {string} input - Entrada a validar
 * @param {string} type - Tipo de validación (username, password, email)
 * @returns {boolean} - True si es válido
 */
export const validateInput = (input, type) => {
  if (!input || typeof input !== "string") return false;

  const patterns = {
    username: /^[a-zA-Z0-9@._-]{3,50}$/,
    password: /^.{8,100}$/,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  };

  return patterns[type] ? patterns[type].test(input) : true;
};

/**
 * Limpia datos sensibles de memoria
 * @param {string} str - String a limpiar
 */
export const secureClear = (str) => {
  if (typeof str !== "string") return;

  // Sobrescribir el string con datos aleatorios
  const length = str.length;
  const randomChars = new Array(length).fill("*").join("");
  str = randomChars; // eslint-disable-line no-param-reassign
};
